var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#2D8CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 27.9503V18.6865C13 18.3075 13.31 18 13.6924 18H27.2028C29.3064 18 31.0133 19.6897 31.0133 21.7741V31.0379C31.0133 31.4169 30.7033 31.7244 30.3209 31.7244H16.8105C14.7068 31.7244 13 30.0347 13 27.9503ZM37.4466 18.233L31.8711 22.3009V27.4395L37.4466 31.5075C37.8411 31.8089 38.3044 31.902 38.3044 31.0792V18.6612C38.3044 17.9276 37.9327 17.8354 37.4466 18.233Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/Zoom.4f933e031b00e2a5b9959725eef0e833.svg";
export { ForwardRef as ReactComponent };